import moment from 'moment'

import Api from 'Api'
import Store from '@/utils/Store'
import UnmappedDomain from '../model/UnmappedDomain'

export default class DomainRepository {

    static #tokenCacheTimeout = 10 // seconds
    static #unmappedDomainsCacheTimeout = 10 // seconds

    static getUnmappedDomains (ignoreCache = false) {
        let reload = ignoreCache
        if (!reload) {
            // Check for cache timeout
            let tmp = Store.state.unmappedDomains
            if (tmp.updated === null) {
                reload = true
            } else {
                let now = moment().utc()
                reload = Math.floor((now - tmp.updated) / 1000) > DomainRepository.#unmappedDomainsCacheTimeout
            }
        }

        // Get records list
        if (!reload) {
            return new Promise((resolve) => { resolve(Store.state.unmappedDomains.list) })
        }

        // Reload unmapped domains
        return new Promise((resolve, reject) => {
            Api.getUnmappedDomains()
                .then(resp => {
                    if (typeof resp.status !== 'number' || resp.status !== 200) {
                        reject('Invalid return status.')
                        return
                    }
                    if (typeof resp.data !== 'object' || !(resp.data instanceof Array)) {
                        reject('Invalid return data.')
                        return
                    }

                    const list = resp.data.map(row => UnmappedDomain.fromObject(row))
                    Store.commit('unmappedDomains', list)
                    resolve(Store.state.unmappedDomains.list)
                })
                .catch(() => {
                    reject('Invalid API response.')
                })
        })
    }

}
